import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-natureza-juridica-pj',
  templateUrl: './natureza-juridica-pj.component.html',
  styleUrls: ['./../cadastral-pj/cadastral-pj.component.css','./natureza-juridica-pj.component.css']
})
export class NaturezaJuridicaPjComponent implements OnInit {

  @Input() dados:any;
  public txtButtonConsultar:string='Consultar agora';
  public consultando:Boolean=false;
  public naoSolicitou:Boolean=false;
  public naoEncontrouRegistros:Boolean=false;
  public modalRef:BsModalRef;
  constructor(private modalService:BsModalService) { }
  

  ngOnInit() {
    if(this.dados.natureza_juridica===undefined){
      this.naoSolicitou=true;
    }else if(this.dados.natureza_juridica===null){
      this.naoEncontrouRegistros=true;
    }
  }

}
